import React from 'react';
import { observer } from 'mobx-react-lite';
import { RadioCard } from 'src/domains/common/components/radio-card/radio-card';
import {
    GamstopPreviouslyPositiveOptions,
    GamstopPreviouslyPositiveSection,
    GamstopPreviouslyPositiveSectionTitle,
} from 'src/components/ComplianceConfiguration/GamstopPreviouslyPositive/GamstopPreviouslyPositive.style';
import {
    GamstopPpAutomatedActionOptionType,
    GamstopPpAutomatedActionType,
} from 'src/components/ComplianceConfiguration/GamstopPreviouslyPositive/GamstopPreviouslyPositive.types';

interface GamstopPreviouslyPositiveActionSectionPropsType {
    title: string;
    options: Array<GamstopPpAutomatedActionOptionType>;
    selectedAction: GamstopPpAutomatedActionType | null;
    onSelect: (value: GamstopPpAutomatedActionType) => void;
    renderAfterOption?: (option: GamstopPpAutomatedActionOptionType) => React.ReactNode;
}

export const GamstopPreviouslyPositiveActionSection = observer(
    ({
        title,
        options,
        selectedAction,
        onSelect,
        renderAfterOption,
    }: GamstopPreviouslyPositiveActionSectionPropsType): JSX.Element => {
        return (
            <GamstopPreviouslyPositiveSection data-test={`gamstop-pp-section-${title.toLowerCase()}`}>
                <GamstopPreviouslyPositiveSectionTitle>{title}</GamstopPreviouslyPositiveSectionTitle>
                <GamstopPreviouslyPositiveOptions>
                    {options.map((option) => (
                        <React.Fragment key={option.value}>
                            <RadioCard
                                dataTest={`gamstop-pp-action-${option.value}`}
                                description={option.description}
                                inputDataTest={`gamstop-pp-action-input-${option.value}`}
                                isSelected={selectedAction === option.value}
                                label={option.label}
                                name='gamstop-pp-automated-action'
                                onSelect={(value): void => {
                                    if (option.value === value) {
                                        onSelect(option.value);
                                    }
                                }}
                                value={option.value}
                            />
                            {renderAfterOption?.(option)}
                        </React.Fragment>
                    ))}
                </GamstopPreviouslyPositiveOptions>
            </GamstopPreviouslyPositiveSection>
        );
    }
);
